module.exports = __webpack_public_path__ + "img/LuckyLarryLobstermaniaClassic_EGM.c76855f1.png";